import { useTheme } from 'next-themes';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster2 = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background-default group-[.toaster]:text-typography-default group-[.toaster]:border-border-default group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-typography-muted',
          actionButton:
            'group-[.toast]:bg-action-enabled group-[.toast]:text-typography-inverted',
          cancelButton:
            'group-[.toast]:bg-background-muted group-[.toast]:text-typography-muted',
        },
      }}
      {...props}
    />
  );
};

export { Toaster2 };
